import { Skeleton, Table } from '@factorialco/deprecated-design-system'
import { range, sample } from 'lodash'

import i18n from 'modules/core/lib/i18n'

export const ApplicationsSourceTypeSkeleton = () => {
  const tableHeaders = [
    i18n.t('ats.insights_page.sources_metrics.table_headings.category'),
    i18n.t('ats.insights_page.sources_metrics.table_headings.candidates'),
  ]

  return (
    <Table hideBorder fullWidth noRadius>
      <Table.Row>
        {tableHeaders.map((header) => (
          <Table.Cell noBorder key={header} paddingX="s0">
            {header}
          </Table.Cell>
        ))}
      </Table.Row>
      {range(5).map((number) => (
        <Table.Row key={number}>
          <Table.Cell noBorder paddingX="s0">
            <Skeleton width={sample(['s80', 's140', 's120'])} />
          </Table.Cell>
          <Table.Cell noBorder paddingX="s0">
            <Skeleton height="s12" width={sample(['s360', 's400', 's300', 'full'])} />
          </Table.Cell>
        </Table.Row>
      ))}
    </Table>
  )
}
